import React from "react";
import ImageCertif from "../../images/2020/12/Yellow-Illustrated-Birthday-Gift-Certificate.png";

function CarteCadeau(props) {
  return (
    <div>
      <h1>La carte cadeau Cékankonjou</h1>

      <div>
        <div
          class="ContentRight WithRightRail RPOn RPBottom"
          data-link="class{:~tag.contentRightClass(Layout.IsFullView, Layout.ReadingPaneMode)}"
        >
          <div class="ContentRightInner t_mbgc t_qtc t_urtc">
            <div
              id="inboxControl0fv-ReadMessageContainer"
              class="v-ReadMessageContainer slideOnResize"
              tabindex="-1"
            >
              <div
                class="c-ReadMessage"
                data-link="class{readMessageClass: ~tag.Show}"
              >
                <div
                  id="ReadMessageScrollableSection"
                  class="rmMessages ClearBoth"
                  tabindex="-1"
                >
                  <div
                    id="readMessagePartControl3076f"
                    class="c-ReadMessagePart ReadMsgContainer HasLayout ClearBoth HideShadows FullPart NoHistory Read RmIc"
                    data-link="class{:~tag.getHeaderCssClass(IsConversationPart, IsRead, IsDraft, IsTrustedSender, Items.length)}"
                  >
                    <div
                      class="c-ReadMessagePartBody"
                      data-link="class{getClass:IsBodyExpanded}"
                    >
                      <div class="readMsgBody">
                        <div
                          id="bodyreadMessagePartBodyControl3081f"
                          class="ExternalClass MsgBodyContainer"
                          data-link="class{:~tag.cssClasses(PlainText, IsContentFiltered)}"
                        >
                          <div dir="ltr">
                            <p>
                              Vous souhaitez faire plaisir a un proche, en voilà
                              une idée originale !
                            </p>
                            <p>
                              La carte cadeau s’achète à la ludothèque
                              itinérante. Elle permettra à la famille, ou à la
                              personne à qui vous l’offrez, de se faire plaisir
                              en empruntant 5 jeux gratuitement et d’être
                              adhérent à la ludothèque pour une année !
                            </p>
                            <p>La carte est disponible pour tout les âges !!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div dir="ltr">
          <a href={ImageCertif}>
            <img
              fetchpriority="high"
              decoding="async"
              class="aligncenter size-full wp-image-1487"
              src={ImageCertif}
              alt=""
              width="100%"
              sizes="(max-width: 1800px) 100vw, 1800px"
            />
          </a>
        </div>
        <div
          class="ContentRight WithRightRail RPOn RPBottom"
          data-link="class{:~tag.contentRightClass(Layout.IsFullView, Layout.ReadingPaneMode)}"
        ></div>
        <div
          id="RightRailContainer"
          class="c-RightRail RightRailContainerWidth t_sbgc"
        ></div>
      </div>
    </div>
  );
}

export default CarteCadeau;
